import React, { FC, PropsWithChildren } from 'react';
import { Tooltip } from '../common/components/Tooltip';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './UserViewPermissionTypeName.translations.json';

const { addTranslations, t } = i18nNsFactory('user-view-permission-type-name');
addTranslations(translations);

export interface UserViewPermissionTypeNameProps {
  type: string;
  short?: boolean;
}

export const UserViewPermissionTypeName: FC<
  PropsWithChildren<UserViewPermissionTypeNameProps>
> = (props) => {
  const { type, short = true } = props;
  const name = getUserViewPermissionTypeName(type, false);

  if (short) {
    return (
      <Tooltip title={name} placement="left">
        {getUserViewPermissionTypeName(type)}
      </Tooltip>
    );
  }

  return name;
};

export const getUserViewPermissionTypeName = (type: string, short = true) =>
  short ? t(`${type}.short-name`) : t(`${type}.name`);
